import {gql} from '@apollo/client'

export const CREATE_CONTACT = gql`
  mutation createContact($contactData: contact_input!) {
    createContact(contactData: $contactData) {
      contact {
        id
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export const EDIT_CONTACT = gql`
  mutation updateContact($id: Int!, $contactData: contact_input!) {
    updateContact(id: $id, contactData: $contactData) {
      success
      errors {
        message
      }
    }
  }
`

export const DELETE_CONTACT = gql`
  mutation deleteContact($id: Int!) {
    deleteContact(id: $id) {
      success
      errors {
        message
      }
    }
  }
`

export const ANALYZE_DUPLICATE_CONTACTS = gql`
  mutation AnalyzeDuplicateContacts($filters: GenericScalar) {
    analyzeDuplicateContacts(filters: $filters) {
      success
      analyzedCount
      truncated
      groups {
        contacts {
          id
          fullName
          email
          phone
          dateBirth
          policyCount
          created
          reasons
        }
      }
      errors {
        message
      }
    }
  }
`

export const MERGE_DUPLICATE_CONTACTS = gql`
  mutation MergeDuplicateContacts($primaryId: Int!, $duplicateIds: [Int]!) {
    mergeDuplicateContacts(primaryId: $primaryId, duplicateIds: $duplicateIds) {
      success
      mergedCount
      contact {
        id
        fullName
      }
      errors {
        message
      }
    }
  }
`
